import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import DashBoardCard from '../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard'
import { PDRL_ADMIN_ROUTES } from '../../routes'
import { getOperationsDashboardOverview } from '../../apis/BhuMeetTeams/BhuMeetAdmin/dashboard'
import { getMarketingDashboardOverview } from '../../apis/BhuMeetTeams/Oparations/marketing'

export default function MarketingStatsDashBoard() {

    const [overviewData,setOverviewData] = useState({})
    const [loading,setLoading] = useState(false)

    useEffect(()=>{
        getoverViewData()
    },[])



    const getoverViewData = async ()=>{

        setLoading(true)
        let getcount = await getMarketingDashboardOverview()
        setLoading(false)
        setOverviewData(getcount)
        console.log(getcount)
    }
    return (
        <MainContentWrapper>
            <div className="dashboard-first-section-second-div" style={{ width: "100%" }} >
                <div className="dashboard-first-section-second-div-one" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }} >
                    <DashBoardCard
                        loading={loading}
                        view={PDRL_ADMIN_ROUTES.MARKETINGNOTIFICATIONHISTORY}
                        title="Notifications History"
                        data={overviewData?.notificationsLogs}
                        icon={""}
                    />
                    <DashBoardCard
                        loading={loading}
                        view={PDRL_ADMIN_ROUTES.TEXTNOTIFICATIONHISTORY}
                        title="Text Notifications History"
                        data={overviewData?.textnotificationsLogsCount}
                        icon={""}
                    />
                   
                    
                </div>
            </div>
        </MainContentWrapper>
    )
}
